'use client';

import { c as _c } from "react/compiler-runtime";
import { CardSlider, CardSliderList, CardSliderListItem } from '@7f-ui/components/card-slider/card-slider';
import { Skeleton } from '@7f-ui/components/skeleton/skeleton';
import { TICKET_DAYS_PREVIEW_COUNT } from '../_hooks/use-app-experience-purchasable-days';
export function AppExperienceTicketDaysSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Array.from({
      length: TICKET_DAYS_PREVIEW_COUNT
    }, _temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const cardKeys = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="h-8 w-40 sm:w-52" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="pointer-events-auto flex items-center justify-between">{t1}<div className="hidden items-center gap-2 sm:flex"><Skeleton variant="circle" className="size-10" /><Skeleton variant="circle" className="size-10" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cardKeys.map(_temp2);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="py-8" data-testid="TicketDays.skeleton"><div className="bleed-container"><CardSlider fullBleed={true}>{t2}<CardSliderList className="-mr-4 xs:-mr-6 w-full pr-1 sm:mr-0" isSlidable={true}>{t3}<CardSliderListItem className="relative grid-cols-3"><div className="flex h-full min-h-24 items-center gap-2 rounded-2xl border border-primary-green/15 bg-white p-6"><Skeleton className="h-4 w-24" /><Skeleton variant="circle" className="size-4" /></div></CardSliderListItem></CardSliderList></CardSlider></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp2(cardKey) {
  return <CardSliderListItem key={cardKey} className="relative grid-cols-3"><div className="flex w-58 flex-col items-start gap-2 rounded-2xl border border-primary-green/15 bg-white p-4"><Skeleton className="h-5 w-8/12" /><Skeleton className="h-4 w-6/12" /></div></CardSliderListItem>;
}
function _temp(_, itemNumber) {
  return `ticket-day-skeleton-${itemNumber + 1}`;
}